"use client";

import { Agentation } from "agentation";

export function AgentationDev() {
  return <Agentation />;
}
